import { LogService } from 'library/ts/utilities/logger/LogService';
const logger = LogService.create({ prefixes: ['SmartTag:'] });
export const blankMP4Base64 = 'data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAC721kYXQhEAUgpBv/w' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAA3pwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCEQBSCkG//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADengAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAsJtb292AAAAbG12aGQAA' +
    'AAAAAAAAAAAAAAAAAPoAAAALwABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAA' +
    'AAAAAAAAAAAAAAAAAADAAAB7HRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAIAAAAAAAAALwAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAA' +
    'AAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAC8AAAAAAAEAAAAAAWRtZGlhAAAAIG1kaGQAAAAA' +
    'AAAAAAAAAAAAAKxEAAAIAFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAEPbWluZgAAABBzbWhkAAAAAAAAA' +
    'AAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAADTc3RibAAAAGdzdHNkAAAAAAAAAAEAAABXbXA0YQAAAAAAAAABAAAAAAAAAAAAAg' +
    'AQAAAAAKxEAAAAAAAzZXNkcwAAAAADgICAIgACAASAgIAUQBUAAAAAAfQAAAHz+QWAgIACEhAGgICAAQIAAAAYc3R0cwAAAAAAAAABAAAAAgAABAAAAA' +
    'Acc3RzYwAAAAAAAAABAAAAAQAAAAIAAAABAAAAHHN0c3oAAAAAAAAAAAAAAAIAAAFzAAABdAAAABRzdGNvAAAAAAAAAAEAAAAsAAAAYnVkdGEAAABabW' +
    'V0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE=';
export const checkAutoplay = (capabilities) => {
    return new Promise((resolve) => {
        const videoURL = 'https://avia.vtg.paramount.tech/h5/blanks/uvp_blank.mp4';
        const info = {
            supportsUnmutedAutoplay: undefined,
            supportsMutedAutoplay: undefined
        };
        let videoElement;
        const createVideoElement = (muted) => {
            const videoElement = document.createElement('video');
            if (muted) {
                videoElement.muted = true;
                videoElement.setAttribute('muted', '');
                videoElement.setAttribute('playsinline', '');
            }
            videoElement.volume = 0.005;
            videoElement.style.width = '400px';
            videoElement.style.height = '225px';
            videoElement.style.position = 'absolute';
            videoElement.style.left = '-1000px';
            videoElement.style.top = '-1000px';
            videoElement.src = blankMP4Base64;
            document.body.appendChild(videoElement);
            return videoElement;
        };
        const removeVideoElement = () => {
            if (videoElement) {
                videoElement.onloadeddata = undefined;
                videoElement.pause();
                videoElement.removeAttribute('src');
                document.body.removeChild(videoElement);
                videoElement = null;
            }
        };
        const isChromeAutoplayEligible = () => {
            return capabilities.getChromeVersion().majorVersion >= 54;
        };
        const isAutoplayEligibleIos = () => {
            const ios10 = (capabilities.iOS().ios === true && parseInt(capabilities.iOS().version.toString().split('.')[0]) >= 10);
            const isOkSafari = (ios10 && capabilities.isSafari);
            const isOkChrome = (ios10 && !isOkSafari && (capabilities.isChromeIOS || capabilities.isChrome) && isChromeAutoplayEligible());
            return isOkSafari || isOkChrome;
        };
        const isAutoplayEligibleAndroid = () => {
            return capabilities.android && capabilities.isChrome && isChromeAutoplayEligible();
        };
        const isEarlySafari11 = () => {
            const isSafariDesktop = capabilities.isSafari && capabilities.isDesktop;
            const safariVersion = isSafariDesktop ? capabilities.safariVersion.version : null;
            const versionArray = safariVersion && safariVersion.split('.');
            const majMinMatch = versionArray ? (parseInt(versionArray[0]) === 11) && (parseInt(versionArray[1]) === 0) : null;
            if (majMinMatch === null)
                return false;
            return majMinMatch && (!versionArray[2] || (parseInt(versionArray[2]) < 3));
        };
        const detectMobileCapabilities = () => {
            const unmutedOk = false;
            const mutedOk = isAutoplayEligibleAndroid() || isAutoplayEligibleIos();
            finishCheck(unmutedOk, mutedOk);
        };
        const setInfo = (unmutedOk, mutedOk) => {
            info.supportsUnmutedAutoplay = unmutedOk;
            info.supportsMutedAutoplay = mutedOk;
        };
        const finishCheck = (unmutedOk, mutedOk) => {
            removeVideoElement();
            setInfo(unmutedOk, mutedOk);
            logger.log('Check Complete', info);
            resolve(info);
        };
        const checkMutedAutoplay = () => {
            removeVideoElement();
            if (isEarlySafari11()) {
                finishCheck(false, false);
                return;
            }
            videoElement = createVideoElement(true);
            videoElement.load();
            const promise = videoElement.play();
            promise
                .then(() => finishCheck(false, true))
                .catch(() => finishCheck(false, false));
        };
        const checkUnmutedAutoplay = () => {
            videoElement = createVideoElement(false);
            videoElement.onloadeddata = (event) => {
                const promise = videoElement.play();
                if (promise === undefined) {
                    if (capabilities.isMobile.any()) {
                        detectMobileCapabilities();
                    }
                    else {
                        finishCheck(true, true);
                    }
                }
                else {
                    promise
                        .then(() => finishCheck(true, true))
                        .catch(() => checkMutedAutoplay());
                }
            };
            videoElement.load();
        };
        if (document.body !== null) {
            checkUnmutedAutoplay();
        }
        else {
            document.addEventListener('DOMContentLoaded', (event) => {
                checkUnmutedAutoplay();
            });
        }
    });
};
